import { useEffect } from "react";

const SITE = "Hovli Liga";

/**
 * Sahifa sarlavhasi va tavsifini yangilaydi.
 *
 * Sayt bitta HTML fayldan iborat (SPA), shuning uchun ular koddan
 * qo'yiladi. Bu Telegramda havola ulashilganda ham, brauzer tarixida ham
 * ko'rinadi. Qidiruv tizimlari uchun asosiy sahifa `index.html` dagi
 * statik sarlavha bilan indekslanadi.
 */
export function usePageMeta(title: string | null, description?: string): void {
  useEffect(() => {
    document.title = title ? `${title} — ${SITE}` : `${SITE} — havaskor futbol uchun Telegram ilovasi`;

    if (description) {
      const tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute("content", description);
    }
  }, [title, description]);
}
